import { useEffect } from 'react';
import { useEventCallback } from '../useEventCallback';

export function useModalLifecycleEffect({
  opened,
  afterOpened
}: {
  opened: boolean;
  afterOpened: () => void;
}): void {
  const handleOpened = useEventCallback(() => {
    afterOpened();
  });

  useEffect(() => {
    if (opened) {
      handleOpened();
    }
  }, [opened, handleOpened]);
}
